import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface ProtelService {
  apiEndpoint: string;
  hotelId: string;
  token: string;
  includeForecastedCharges: boolean;
}

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    apiEndpoint: '',
    hotelId: '',
    token: '',
    includeForecastedCharges: false,
  },
  features: {},
  cron: [],
  webhooks: [],
});

export const protel: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as ProtelService;

    test(`${SERVICE}.apiEndpoint`, t('validations.required'), () => {
      enforce(service.apiEndpoint).isNotBlank();
    });

    omitWhen(!service.apiEndpoint, () => {
      test(`${SERVICE}.apiEndpoint`, t('validations.url'), () => {
        enforce(isEndpointUrl(service.apiEndpoint)).isTruthy();
      });
    });

    for (const field of ['hotelId', 'token'] as const) {
      test(`${SERVICE}.${field}`, t('validations.required'), () => {
        enforce(service[field]).isNotBlank();
      });
    }

    test(
      `${SERVICE}.includeForecastedCharges`,
      t('validations.required'),
      () => {
        enforce(service.includeForecastedCharges).isBoolean();
      }
    );
  },
};
